'use client';

import styled from 'styled-components';
import TripAdvisorBubbles from '@/app/components/hotel-detail/trip-advisor/TripAdvisorBubbles.tsx';
import { ratingScoreLabel } from '@/app/common/filters/core/ratingValues.ts';
import { Text } from '@/app/common/filters/types/shared/styled/Text.styled.ts';

// Text keeps the 24px option-row line box every other filter label has, so the row stays 40px tall.
const EvoRatingStyled = styled(Text)`
  gap: 8px;
`;

const Threshold = styled.span`
  font-weight: 700;
`;

const Bubbles = styled(TripAdvisorBubbles)`
  font-size: 14px;
`;

type Props = {
  score: number;
};

// The threshold beside them already reads the score, and "out of 5" misstates a lower bound.
const EvoRatingLabel = ({ score }: Props) => (
  <EvoRatingStyled>
    <Threshold>{ratingScoreLabel(score)}</Threshold>
    <Bubbles value={score} aria-hidden="true" />
  </EvoRatingStyled>
);

export default EvoRatingLabel;
